// src/components/common/BackButton.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BackButton.css'; // Vamos criar este arquivo de estilo a seguir.

/**
 * Um botão flutuante que navega para a página anterior no histórico do navegador.
 * Este componente encapsula a lógica do `useNavigate` e o estilo CSS.
 */
const BackButton = () => {
  const navigate = useNavigate();

  // A função para voltar. O -1 significa "volte uma página no histórico".
  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <button
      type="button"
      onClick={handleGoBack}
      className="floating-back-button"
      aria-label="Voltar para a página anterior"
      title="Voltar"
    >
      ← {/* Entidade HTML para uma seta para a esquerda */}
    </button>
  );
};

export default BackButton;